import { createAsyncThunk } from "@reduxjs/toolkit";
import CAxios from "../utils/CAxios";

export const ToSearch = createAsyncThunk(
  "portal/search",
  async ({ name, lang }: { name: string; lang: string }) => {
    try {
      const response = await CAxios.post(`portal/search?lang=${lang}`, { name });
      return response;
    } catch (error) {
      throw error;
    }
  }
);

